/* eslint-disable */
import React from 'react'
import cls from './seoIndex.module.sass'

const EnSeoInfo = () => {
    return <div className={cls["page_desc"]}>

        <p>I'm Bob, the creator of this <strong>sex revealing site</strong>, I am pleased to
            welcome you at Bob Voyeur, a site for <strong>real</strong> with a 100% <strong>amateur</strong>
            {' '}submitted explicit content.</p>

        <p>Bob Voyeur is a site dedicated to exhibitionism and voyeurism. Over 5 years
            thousands of <strong>swinger couples</strong>, amateur horny women and men trust me and
            place their <strong>sexually explicit videos</strong> and candid <strong>erotic photos</strong>
            {' '}showing real exciting sex exciting sex in all its forms and sharing with
            millions of watchers.</p>

        <p>Bob Voyeur community is the largest <strong>exhibitionist community,</strong> of the
            Internet in France, the daily exhibition of thousands of nasty loving{' '}
            <strong>couples</strong>, <strong>voyeurism</strong>, <strong>group sex</strong> and even <strong>swinging</strong>.</p>

        <p>Every day I receive dozens of skilful amateur contributions sent to me by{' '}
            <strong>wicked couples</strong>, <strong>nasty men</strong> or <strong>sexy housewives</strong> and I
            immediately publish it to the delighted and anticipated voyeurs.
                All published photos and videos are classified in different sections of the site
                and we have a very large number of <strong>free content</strong>.</p>

        <p>The <strong>exciting</strong> nude SOFT photos and porn VIDEOS less 30 seconds long are published
            in the <strong>free section</strong> of Bob Voyeur.
                HOT photos, long explicit VIDEOS over 30 seconds long, contributions to special themes and
                archives of the site are published in Premium.</p>

        <p>You can also share your <strong>private nude photos</strong> and <strong>erotic videos</strong>
            {' '}with all <strong>naughty amateurs</strong> of the exhibitionists community. Registration
            is <strong>free</strong>. Within minutes you can upload your naked wife's photos or
            girlfriends nude video anonymously on the "Upload your photos" and attach your
            ad text that will allow you to be immediately in contact with thousands of
            couples, men and women who will appreciate your contribution and be glad to know
            you ;-)</p>

        <p>The most important thing for me is that all the <strong>pornographic photos</strong>
            {' '}and <strong>porn videos</strong> posted on Bob Voyeur are authentic and real{' '}
            <strong>amateur</strong>.
                {' '}The "Certified Amateurs" section includes several hundred real amateurs who
                have proved their authenticity by sending me a certified photo..
                The nude photos or videos stolen from the Internet, of bad quality or lacking of
                aesthetics are not published. Only quality <strong>erotic contributions</strong> are
                posted online all day and the most exciting pictures are selected to appear on
                the page "The best photos".</p>

        <p>A free email service allows you to send a message to <strong>amateurs</strong> who
            posted their private <strong>photo</strong> or sex <strong>video</strong>. Simply register free to
            send a message and leave your comments for couples, women and men of your
            choice. You can attach your photos to your pleasant personal message and start
            sharing your own <strong>naughty photos</strong> and homemade <strong>videos</strong> with them.</p>

        <p>Whatever you are looking for, your satisfaction, your desire or your sexy
            fantasy you can meet couples, men and women who have something piquant and hot
            to share with you.
                Bob Voyeur community is dedicated to all naughty adults, swingers and includes
                all the trends: <strong>voyeurism</strong>, <strong>swinging</strong>, <strong>group sex</strong> and{' '}
                <strong>exhibitionism</strong>. If you wish you can share everything, realize your sexual
                fantasy and make real your erotic meetings with mixed couples, nude housewives
                and swingers.</p>

        <p>Welcome to the worship places of sex, charm, eroticism, fantasy, swinging and
            porn.</p>

        <p>If you are a man, you like to exhibit you, you are looking for other sexy men
            and women or amateur couples, you should visit the <strong>gay and transvestite</strong>
            {' '}version of Bob Voyeur. My site <a href="http://www.bob4men.com">www.bob4men.com</a>
            {' '}is reserved for <strong>adult male exhibitionists</strong> ;-)</p>

        <p>
            And finally, if you want to go even further in the exhibitionism and voyeurism,
            to meet libertine and naughty amateur couples, I invite you to discover{' '}
            <a href="http://www.bobtv.fr">www.bobTV.fr</a> the largest <strong>adult webcam
            chat</strong> in France. You are welcome 24 hours of 24 and 7 days of 7 on the
            biggest chat rooms platform in France.
            bobTV is a new way of chatting about sex, being naked cam to cam, and <strong>meeting
            naughty couples</strong> making love in front of their webcams and practicing the
            swinging.</p>

        <p>Enjoy your naughty visit at all voyeurs, share your fantasies and enjoy yourself ;-)</p>

        <p>Bob</p>
    </div>
}

export default EnSeoInfo
